import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlertCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.875 15.125C11.7408 15.125 14.8747 11.9908 14.875 8.125C14.875 4.25901 11.741 1.125 7.875 1.125C4.00922 1.12526 0.875 4.25916 0.875 8.125C0.875256 11.9906 4.00938 15.1247 7.875 15.125ZM7.875 14.125C4.56167 14.1247 1.87526 11.4383 1.875 8.125C1.875 4.81145 4.56151 2.12526 7.875 2.125C11.1887 2.125 13.875 4.81129 13.875 8.125C13.8747 11.4385 11.1886 14.125 7.875 14.125ZM7.98242 9C8.25856 9 8.48242 8.77614 8.48242 8.5V4.5C8.48242 4.22386 8.25856 4 7.98242 4C7.70648 4.00023 7.48242 4.224 7.48242 4.5V8.5C7.48242 8.776 7.70648 8.99977 7.98242 9ZM8 11.5098C8.27603 11.5098 8.49981 11.2857 8.5 11.0098C8.5 10.7336 8.27614 10.5098 8 10.5098C7.72386 10.5098 7.5 10.7336 7.5 11.0098C7.50019 11.2857 7.72397 11.5098 8 11.5098Z",
		fill: "currentColor"
	})
});
export default SvgAlertCircle;
